/* Hawkins homepage reviews carousel.
   Extracted 2026-07-27 from the inline section script so the 13KB of logic
   no longer blocks the HTML parser; the review data stays in the section as
   an application/json block (same array, same update procedure). */
(function() {
  function initHawkinsReviews(cfg) {
    var SECTION_ID = cfg.sectionId;
    var VISIBLE_DESKTOP = parseInt(cfg.cardsDesktop, 10) || 3;
    var VISIBLE_MOBILE = parseInt(cfg.cardsMobile, 10) || 1;
    var AUTO_ADVANCE_MS = parseInt(cfg.autoplayMs, 10) || 0;
    var MAX_REVIEWS = parseInt(cfg.maxReviews, 10) || 30;
    var ALL_REVIEWS = cfg.reviews || [];


      // --- Shuffle ---
      function shuffle(arr) {
        var a = arr.slice();
        for (var i = a.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
        }
        return a;
      }

      // Filter out very short reviews, newest first, limit count
      var reviews = ALL_REVIEWS.filter(function(r) {
        return r.body && r.body.length > 30;
      }).sort(function(a, b) {
        return String(b.date || '').localeCompare(String(a.date || ''));
      }).slice(0, MAX_REVIEWS);

      if (reviews.length < 2) return; // not enough to show

      var track = document.getElementById('hawkins-track-' + SECTION_ID);
      var dotsEl = document.getElementById('hawkins-dots-' + SECTION_ID);
      var viewportEl = document.getElementById('hawkins-carousel-' + SECTION_ID).querySelector('.hawkins-carousel-viewport');
      var section = document.getElementById('hawkins-carousel-' + SECTION_ID);
      var prevBtn = section.querySelector('.hawkins-carousel-btn--prev');
      var nextBtn = section.querySelector('.hawkins-carousel-btn--next');

      var currentIndex = 0;
      var autoTimer = null;

      function getVisible() {
        return window.innerWidth < 768 ? VISIBLE_MOBILE : VISIBLE_DESKTOP;
      }

      function starHTML(rating) {
        var html = '<span class="hawkins-cr-stars" aria-label="' + rating + ' out of 5 stars">';
        for (var i = 1; i <= 5; i++) {
          html += i <= rating
            ? '<span class="hawkins-cr-star filled">★</span>'
            : '<span class="hawkins-cr-star">☆</span>';
        }
        html += '</span>';
        return html;
      }

      function escapeHTML(str) {
        if (!str) return '';
        return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
      }

      function formatDate(dateStr) {
        if (!dateStr) return '';
        var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var parts = dateStr.split('-');
        if (parts.length < 3) return dateStr;
        var m = parseInt(parts[1], 10) - 1;
        var d = parseInt(parts[2], 10);
        return months[m] + ' ' + d + ', ' + parts[0];
      }

      // Resize Shopify CDN images by injecting _WxH_crop_center before the extension
      function shopifyThumb(url, px) {
        return url.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + px + 'x' + px + '_crop_center$1$2');
      }

      function buildCard(r) {
        var photos = Array.isArray(r.photos) ? r.photos : [];
        var photoHTML = '';
        if (photos.length > 0) {
          photoHTML = '<div class="hawkins-cr-photos">';
          photos.slice(0, 3).forEach(function(url) {
            var thumb = shopifyThumb(url, 120); // 120px = crisp at 2× (60px display)
            photoHTML += '<img src="' + escapeHTML(thumb) + '" alt="Customer photo" class="hawkins-cr-photo" loading="lazy" onerror="this.style.display=\'none\';var p=this.parentElement;if(p&&!p.querySelector(\'img:not([style])\'))p.style.display=\'none\'">';
          });
          photoHTML += '</div>';
        }
        var verifiedBadge = '<span class="hawkins-cr-verified">&#10003; Verified Buyer</span>';
        var CLAMP_CHARS = 160;
        var bodyFull = escapeHTML(r.body);
        var bodyShort = r.body.length > CLAMP_CHARS ? escapeHTML(r.body.slice(0, CLAMP_CHARS).trimEnd()) : null;
        var bodyHTML = bodyShort
          ? '<p class="hawkins-cr-body">' +
              '<span class="hawkins-cr-body-short">' + bodyShort + '&#8230;</span>' +
              '<span class="hawkins-cr-body-full" style="display:none">' + bodyFull + '</span>' +
              '<button class="hawkins-cr-seemore" onclick="(function(btn){' +
                'var card=btn.closest(\'.hawkins-cr-card\');' +
                'var s=card.querySelector(\'.hawkins-cr-body-short\');' +
                'var f=card.querySelector(\'.hawkins-cr-body-full\');' +
                'if(f.style.display===\'none\'){f.style.display=\'\';s.style.display=\'none\';btn.textContent=\'See less\';}' +
                'else{f.style.display=\'none\';s.style.display=\'\';btn.textContent=\'See more\';}' +
              '})(this)" type="button">See more</button>' +
            '</p>'
          : '<p class="hawkins-cr-body">' + bodyFull + '</p>';
        return '<div class="hawkins-cr-card">' +
          starHTML(r.rating) +
          (r.title ? '<p class="hawkins-cr-title">' + escapeHTML(r.title) + '</p>' : '') +
          bodyHTML +
          verifiedBadge +
          photoHTML +
          '<p class="hawkins-cr-meta">' +
            '<span class="hawkins-cr-name">' + escapeHTML(r.name) + '</span>' +
            (r.date ? '<span class="hawkins-cr-date">' + escapeHTML(formatDate(r.date)) + '</span>' : '') +
          '</p>' +
        '</div>';
      }

      function renderCards() {
        track.innerHTML = reviews.map(buildCard).join('');
      }

      function buildDots() {
        var visible = getVisible();
        var pageCount = Math.ceil(reviews.length / visible);
        dotsEl.innerHTML = '';
        for (var i = 0; i < pageCount; i++) {
          var dot = document.createElement('button');
          dot.className = 'hawkins-carousel-dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
          (function(idx) {
            dot.addEventListener('click', function() { goTo(idx * visible); });
          })(i);
          dotsEl.appendChild(dot);
        }
      }

      function updateDots() {
        var visible = getVisible();
        var dots = dotsEl.querySelectorAll('.hawkins-carousel-dot');
        var activePage = Math.round(currentIndex / visible);
        dots.forEach(function(d, i) {
          d.classList.toggle('active', i === activePage);
        });
      }

      // Size the viewport to the cards on screen so short reviews don't
      // leave the blank vertical space the tallest card would need.
      function syncHeight() {
        var visible = getVisible();
        var cards = track.children;
        var last = Math.min(currentIndex + visible, cards.length);
        // Equalize only the on-screen cards; a min-height left on off-screen
        // cards would ratchet every later measurement up to the tallest ever.
        for (var r = 0; r < cards.length; r++) {
          cards[r].style.minHeight = '';
        }
        var h = 0;
        for (var i = currentIndex; i < last; i++) {
          h = Math.max(h, cards[i].offsetHeight);
        }
        // Side-by-side with the lead tile, match its height so tile bottoms align.
        var leadEl = section.querySelector('.hawkins-lead-tile');
        if (leadEl && window.innerWidth >= 990) {
          h = Math.max(h, leadEl.offsetHeight);
        }
        if (h > 0) {
          for (var v = currentIndex; v < last; v++) {
            cards[v].style.minHeight = h + 'px';
          }
          viewportEl.style.height = h + 'px';
        }
      }

      function applyTransform() {
        var visible = getVisible();
        var cardWidth = 100 / visible;
        var offset = -(currentIndex * cardWidth);
        track.style.transform = 'translateX(' + offset + '%)';
        updateDots();
        syncHeight();
      }

      function goTo(idx) {
        var visible = getVisible();
        var maxIndex = reviews.length - visible;
        currentIndex = Math.max(0, Math.min(idx, maxIndex));
        applyTransform();
      }

      function next() {
        var visible = getVisible();
        if (currentIndex + visible >= reviews.length) {
          goTo(0);
        } else {
          goTo(currentIndex + 1);
        }
      }

      function prev() {
        var visible = getVisible();
        if (currentIndex === 0) {
          goTo(reviews.length - visible);
        } else {
          goTo(currentIndex - 1);
        }
      }

      function startAuto() {
        if (AUTO_ADVANCE_MS > 0) {
          autoTimer = setInterval(next, AUTO_ADVANCE_MS);
        }
      }

      function stopAuto() {
        if (autoTimer) clearInterval(autoTimer);
      }

      // Init
      renderCards();
      buildDots();
      applyTransform();

      // Set card widths via CSS variable
      function setCardWidth() {
        var visible = getVisible();
        track.style.setProperty('--hw-card-width', (100 / visible) + '%');
        buildDots();
        applyTransform();
      }
      setCardWidth();

      var statsEl = section.querySelector('[data-hawkins-stats]');
      if (statsEl && ALL_REVIEWS.length) {
        var avgText = (cfg.statsAverage || '') + '';
        var countText = (cfg.statsCount || '') + '';
        if (!avgText) {
          var ratingSum = 0;
          for (var ri = 0; ri < ALL_REVIEWS.length; ri++) {
            ratingSum += (parseFloat(ALL_REVIEWS[ri].rating) || 0);
          }
          avgText = (ratingSum / ALL_REVIEWS.length).toFixed(1);
        }
        if (!countText) {
          countText = String(ALL_REVIEWS.length);
        }
        statsEl.innerHTML =
          '<span class="hawkins-lead-tile__avg">' + avgText + ' average</span>' +
          '<span class="hawkins-lead-tile__count">' + countText + ' ratings</span>';
      }

      prevBtn.addEventListener('click', function() { stopAuto(); prev(); startAuto(); });
      nextBtn.addEventListener('click', function() { stopAuto(); next(); startAuto(); });

      // photos lazy-load (or fail and get hidden) and "See more" all change card heights
      track.addEventListener('load', syncHeight, true);
      track.addEventListener('error', function() { setTimeout(syncHeight, 50); }, true);
      section.addEventListener('click', function(e) {
        if (e.target && e.target.className && String(e.target.className).indexOf('hawkins-cr-seemore') > -1) {
          syncHeight();
        }
      });

      section.addEventListener('mouseenter', stopAuto);
      section.addEventListener('mouseleave', startAuto);

      window.addEventListener('resize', function() {
        setCardWidth();
      });

      // Pause auto-advance while the carousel is off-screen
      if ('IntersectionObserver' in window) {
        var visObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) { startAuto(); } else { stopAuto(); }
          });
        }, { threshold: 0.1 });
        visObserver.observe(section);
      } else {
        startAuto();
      }

      // Touch/swipe
      var touchStartX = 0;
      var viewport = section.querySelector('.hawkins-carousel-viewport');
      viewport.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      viewport.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          stopAuto();
          if (dx < 0) next(); else prev();
          startAuto();
        }
      }, { passive: true });
  }

  function boot() {
    var blocks = document.querySelectorAll('script[type="application/json"][data-hawkins-reviews-config]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].dataset.hawkinsInit) continue;
      blocks[i].dataset.hawkinsInit = '1';
      try { initHawkinsReviews(JSON.parse(blocks[i].textContent)); } catch (e) { /* leave section empty rather than break the page */ }
    }
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
